import { lazy } from "react";
const DbBase = lazy(() => import("app/pages/db/DbBase"));
const DbUserConfig = lazy(() => import("../pages/db/user/DbUserConfig"));

export const dbRouter: any = [
  {path: "/db", element: <DbBase /> },
  {path: "/db/user/config", element: <DbUserConfig/>},
  /* 예전 "나의 대시보드" 주소. 위젯 대시보드가 /db 로 합쳐졌다 */
  {path: "/db/user/custom", element: <DbBase/>},
];
